import { createContext, useContext, useState, useCallback } from "react";
import { api } from "../lib/api";

const LocationContext = createContext(null);
const KEY = "fixigo_location";

function readStored() {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
}

export function LocationProvider({ children }) {
  const [loc, setLoc] = useState(readStored);   // { pincode, city, state, locality, serviceable, services }
  const [loading, setLoading] = useState(false);

  const persist = (value) => {
    setLoc(value);
    if (value) localStorage.setItem(KEY, JSON.stringify(value));
    else localStorage.removeItem(KEY);
  };

  const setPincode = useCallback(async (pincode) => {
    if (!/^\d{6}$/.test(pincode)) throw new Error("Enter a valid 6-digit pincode");
    setLoading(true);
    try {
      const { data } = await api.get(`/public/serviceability/${pincode}`);
      const value = {
        pincode,
        serviceable: !!data.serviceable,
        city: data.city || "",
        state: data.state || "",
        locality: data.locality || "",
        services: data.services || [],
      };
      persist(value);
      return value;
    } finally { setLoading(false); }
  }, []);

  const clear = useCallback(() => persist(null), []);

  return (
    <LocationContext.Provider value={{ loc, loading, setPincode, clear }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocationCtx() {
  return useContext(LocationContext) || { loc: null, loading: false, setPincode: async () => {}, clear: () => {} };
}
